<template>
  <div class="contact-us-container">
    <div class="contact-info">
      <p class="contact-title">Contact Us</p>
      <p class="contact-intro">+86 18661220409</p>
      <div class="address">
        <p>HQ and MFG Base:</p>
        <p>{{ $t('series.contact_one') }}</p>
        <p>{{ $t('series.contact_two') }}</p>
      </div>
    </div>

    <div class="image-container">
      <!-- 原图 static/contact/big.png 已损坏，暂时用公司 logo 占位，拿到原图后换回 -->
      <img
          src="../static/home/logo.png"
          alt="公司Logo"
          class="contact-image"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      // 可以在这里添加数据，如果需要动态渲染的话
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);

    const masterTimeline = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.contact-us-container',
        start: 'top 80%',
        end: 'bottom 0%',
        markers: false,
        // scrub: 1,
        // once: true,
        toggleActions: 'play none none reverse'
      }
    })
    masterTimeline.from('.contact-us-container', {
      opacity: 0,
      duration: 1.5
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 响应式处理逻辑
    }
  }
};
</script>

<style scoped>
/* 移除CSS变量定义，直接使用具体值 */

/* 基础样式 */
.contact-us-container {
  display: flex;
  flex-direction: row;
  padding: 20px; /* 8px * 2.5 = 20px */
  max-width: 1200px;
  margin: 0 auto;
  min-height: 60vh;
  align-items: center;
  box-sizing: border-box;
  margin-top: 50px; /* 与上方元素保持50px距离 */
}

.contact-info {
  flex: 1;
  padding: 20px; /* 8px * 2.5 = 20px */
}

/* 标题样式 */
.contact-title {
  font-size: 2.5rem; /* 直接使用具体值 */
  color: #0f9ed5;
  margin-bottom: 12px; /* 8px * 1.5 = 12px */
  width: 100%;
  line-height: 1.2;
  font-weight: 600;
  margin-top: 0;
}

.contact-intro {
  font-size: 1.5rem; /* 直接使用具体值 */
  color: #0f9ed5;
  margin-bottom: 48px; /* 8px * 6 = 48px */
  line-height: 1.6;
  margin-top: 0;
}

.address p {
  font-size: 1rem; /* 直接使用具体值 */
  color: #333;
  margin: 10px 0; /* 8px * 1.25 = 10px */
  line-height: 1.6;
}

.image-container {
  flex: 1;
  padding: 20px; /* 8px * 2.5 = 20px */
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-image {
  max-width: 280px;
  width: 100%;
  height: auto;
  border-radius: 0;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .contact-us-container {
    flex-direction: column;
    padding: 15px; /* 8px * 1.875 = 15px */
    margin-top: 30px;
  }

  .contact-info {
    width: 100%;
    padding: 50px 0; /* 8px * 6.25 = 50px */
    order: 1;
  }

  .image-container {
    display: none;
  }

  .contact-title {
    font-size: 2rem;
    margin-bottom: 15px; /* 8px * 1.875 = 15px */
    text-align: center;
  }

  .contact-intro {
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: 20px; /* 8px * 2.5 = 20px */
  }

  .address {
    padding-left: 8px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .contact-title {
    font-size: 2.2rem;
  }

  .contact-us-container {
    padding: 30px; /* 8px * 3.75 = 30px */
    margin-top: 40px;
  }
}
</style>
